import React, { useEffect, useRef } from "react";
import { Table } from "antd";

interface Props {
    data: any[];
    rowKey: string;
    columns: any[];
    loading: boolean;
    hasNext: boolean;
    loadMore: () => void;
    expandable?: {
        expandedRowRender: any,
        onExpand: any,
        expandedRowKeys: any
    };
    bordered?: boolean;
    className?: string;
}

const InfiniteScrollTable: React.FC<Props> = ({
                                                  data,
                                                  columns,
                                                  loading,
                                                  hasNext,
                                                  loadMore,
                                                  expandable,
                                                  rowKey,
                                                  bordered,
                                                  className
                                              }) => {

    const wrapperRef = useRef<HTMLDivElement>(null);
    const lockRef = useRef(false);

    useEffect(() => {
        if (!loading) {
            lockRef.current = false;
        }
    }, [loading]);

    useEffect(() => {
        const tableBody = wrapperRef.current?.querySelector(
            ".ant-table-body"
        ) as HTMLElement;

        if (!tableBody) return;

        const handleScroll = () => {
            if (lockRef.current || !hasNext) return;

            const {scrollTop, scrollHeight, clientHeight} = tableBody;

            const isNearBottom =
                scrollTop + clientHeight >= scrollHeight - 100;

            console.log(isNearBottom, '12345', scrollTop, clientHeight, scrollHeight);


            if (isNearBottom) {
                lockRef.current = true;
                loadMore();
            }
        };

        tableBody.addEventListener("scroll", handleScroll);

        return () => {
            tableBody.removeEventListener("scroll", handleScroll);
        };

    }, [hasNext, loadMore, data]);

    return (
        <div ref={wrapperRef} className={className}>
            <Table
                className={'hrms__table-component'}
                columns={columns}
                dataSource={data}
                pagination={false}
                loading={loading}
                scroll={{y: 200}}
                {...(expandable ? {expandable} : {})}
                {...(bordered ? {bordered} : {})}
                rowKey={rowKey ?? "id"}
            />
        </div>
    );
};

export default InfiniteScrollTable;
